<div class="flex h-full min-h-0 w-full flex-col">
  <!-- header -->
  <div class="flex items-start justify-between px-6" [ngClass]="shortScreen ? 'pt-3' : 'pt-6'">
    <div class="min-w-0">
      <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.TITLE' | t }}</h2>
      @if (!shortScreen) {
      <p class="text-secondary text-sm"
        [innerHTML]="(isReadonly ? 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.SUBTITLE_READONLY' : 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.SUBTITLE_EDIT') | t: { product: data.productLabel }"></p>
      }
    </div>
    <button mat-icon-button type="button" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- resumen -->
  @if (shortScreen) {
  <div class="flex flex-wrap items-center gap-x-4 gap-y-1 px-6 py-2 text-sm">
    <span>
      <span class="text-secondary uppercase">{{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.REQUESTED' | t }}</span>
      <strong class="ml-1">{{ data.requested | dgNumber:'stock' }} {{ data.unitLabel }}</strong>
    </span>
    <span>
      <span class="text-secondary uppercase">{{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.ASSIGNED' | t }}</span>
      <strong class="ml-1" [class.text-green-600]="coversRequested">
        {{ assigned | dgNumber:'stock' }} {{ data.unitLabel }}
      </strong>
    </span>
    <span>
      <span class="text-secondary uppercase">{{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.PENDING' | t }}</span>
      <strong class="ml-1" [class.text-red-500]="pending > 0">
        {{ pending | dgNumber:'stock' }} {{ data.unitLabel }}
      </strong>
    </span>
  </div>
  } @else {
  <div class="grid grid-cols-1 gap-3 px-6 py-4 sm:grid-cols-3">
    <div class="flex flex-col rounded-xl border px-4 py-3">
      <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.REQUESTED' | t }}</span>
      <span class="text-lg font-semibold">{{ data.requested | dgNumber:'stock' }} {{ data.unitLabel }}</span>
    </div>
    <div class="flex flex-col rounded-xl border px-4 py-3">
      <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.ASSIGNED' | t }}</span>
      <span class="text-lg font-semibold" [class.text-green-600]="coversRequested">
        {{ assigned | dgNumber:'stock' }} {{ data.unitLabel }}
      </span>
    </div>
    <div class="flex flex-col rounded-xl border px-4 py-3">
      <span class="text-secondary text-xs uppercase">{{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.PENDING' | t }}</span>
      <span class="text-lg font-semibold" [class.text-red-500]="pending > 0">
        {{ pending | dgNumber:'stock' }} {{ data.unitLabel }}
      </span>
    </div>
  </div>
  }

  @if (isShortOnStock) {
  <div class="mx-6 mb-2 flex items-start gap-2 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 dark:bg-amber-900/20">
    <mat-icon class="icon-size-5 shrink-0 text-amber-600">info</mat-icon>
    <span class="text-sm">
      <span [innerHTML]="'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.SHORT_STOCK_INTRO' | t: {
        available: (totalAvailable | dgNumber:'stock') + ' ' + data.unitLabel,
        requested: (data.requested | dgNumber:'stock') + ' ' + data.unitLabel
      }"></span>
      @if (data.allowsWithoutStock) {
      <span [innerHTML]="'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.SHORT_STOCK_WITHOUT_INVENTORY' | t"></span>
      } @else {
      {{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.SHORT_STOCK_CONFIRM_HINT' | t }}
      }
    </span>
  </div>
  }

  <!-- acciones rápidas -->
  @if (!isReadonly) {
  <div class="flex flex-wrap items-center justify-end gap-2 px-6 pb-3">
    <button mat-stroked-button color="primary" type="button" [disabled]="!canFillAutomatically"
      [matTooltip]="'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.AUTO_FILL_TOOLTIP' | t"
      (click)="fillAutomatically()">
      <mat-icon>auto_fix_high</mat-icon>
      {{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.AUTO_FILL' | t }}
    </button>
    <button mat-button type="button" (click)="clear()">{{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.CLEAR' | t }}</button>
  </div>
  }

  <!-- almacenes, móvil: tarjetas -->
  <div class="min-h-0 flex-1 overflow-auto border-t p-3 md:hidden">
    <div class="flex flex-col gap-3">
      @for (row of rows; track $index) {
      <div class="flex flex-col rounded-xl border bg-card p-3"
        [class.opacity-50]="row.available <= 0 && !row.withoutStock">
        <div class="flex min-w-0 flex-col gap-1">
          <span class="inline-flex flex-wrap items-center gap-1.5">
            <span class="text-primary font-semibold">{{ row.warehouseCode }}</span>
            @if (row.withoutStock) {
            <span class="rounded-full bg-red-100 px-2 py-0.5 text-[10px] font-semibold text-red-700 dark:bg-red-900/40 dark:text-red-300">
              {{ 'DOCUMENT_GENERATE.BADGES.NO_STOCK' | t }}
            </span>
            }
          </span>
          <span class="text-sm uppercase">{{ row.warehouseName }}</span>
          @if (row.withoutStock) {
          <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.SELLS_OVER_STOCK' | t }}</span>
          } @else if ($first && !isReadonly) {
          <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.DOCUMENT_WAREHOUSE' | t }}</span>
          }
        </div>

        <div class="mt-3 flex flex-col gap-2 border-t pt-3 text-sm">
          @if (!isReadonly) {
          <div class="flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.FIELDS.AVAILABLE' | t }}</span>
            <span class="font-semibold" [class.text-green-600]="row.available > 0"
              [class.text-red-500]="row.available <= 0">
              @if (row.withoutStock) { — } @else { {{ row.available | dgNumber:'stock' }} }
            </span>
          </div>
          }
          <div class="flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.FIELDS.QUANTITY' | t }}</span>
            @if (isReadonly) {
            <span class="font-semibold">{{ row.quantity | dgNumber:'stock' }}</span>
            } @else if (row.withoutStock) {
            <span class="rounded-md border border-red-300 px-2 py-1 text-center font-semibold text-red-600">
              {{ row.quantity | dgNumber:'stock' }}
            </span>
            } @else {
            <input type="text" inputmode="decimal" [ngModel]="row.quantityText"
              (ngModelChange)="onQuantityInput(row, $event)" (keydown)="onQuantityKeydown($event)"
              [disabled]="row.available <= 0" [class.cursor-not-allowed]="row.available <= 0"
              class="dg-qty-input w-28 rounded-md border px-2 py-1.5 text-center dark:bg-transparent">
            }
          </div>
        </div>
      </div>
      } @empty {
      <div class="text-secondary flex h-32 items-center justify-center px-4 text-center text-sm">
        {{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.EMPTY' | t }}
      </div>
      }
    </div>
  </div>

  <!-- almacenes, desktop/tablet: tabla -->
  <div class="hidden min-h-0 flex-1 overflow-auto border-t md:block">
    <table class="w-full min-w-[560px] border-collapse text-sm">
      <thead class="sticky top-0 z-10 bg-gray-50 dark:bg-gray-800">
        <tr class="text-secondary text-left">
          <th class="px-6 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.WAREHOUSE' | t }}</th>
          @if (!isReadonly) {
          <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.AVAILABLE' | t }}</th>
          }
          <th class="px-4 py-3 text-center font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.QUANTITY' | t }}</th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track $index) {
        <tr class="border-t" [class.opacity-50]="row.available <= 0 && !row.withoutStock">
          <td class="px-6 py-3">
            <div class="flex min-w-0 flex-col gap-1">
              <span class="inline-flex flex-wrap items-center gap-1.5">
                <span class="text-primary font-semibold">{{ row.warehouseCode }}</span>
                @if (row.withoutStock) {
                <span class="rounded-full bg-red-100 px-2 py-0.5 text-[10px] font-semibold text-red-700 dark:bg-red-900/40 dark:text-red-300">
                  {{ 'DOCUMENT_GENERATE.BADGES.NO_STOCK' | t }}
                </span>
                }
              </span>
              <span class="uppercase">{{ row.warehouseName }}</span>
              @if (row.withoutStock) {
              <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.SELLS_OVER_STOCK' | t }}</span>
              } @else if ($first && !isReadonly) {
              <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.DOCUMENT_WAREHOUSE' | t }}</span>
              }
            </div>
          </td>
          @if (!isReadonly) {
          <td class="px-4 py-3 text-right font-semibold"
            [class.text-green-600]="row.available > 0" [class.text-red-500]="row.available <= 0">
            @if (row.withoutStock) { — } @else { {{ row.available | dgNumber:'stock' }} }
          </td>
          }
          <td class="px-4 py-3">
            <div class="flex justify-center">
              @if (isReadonly) {
              <span class="w-24 text-center font-semibold">{{ row.quantity | dgNumber:'stock' }}</span>
              } @else if (row.withoutStock) {
              <span class="w-24 rounded-md border border-red-300 px-2 py-1 text-center font-semibold text-red-600">
                {{ row.quantity | dgNumber:'stock' }}
              </span>
              } @else {
              <input type="text" inputmode="decimal" [ngModel]="row.quantityText"
                (ngModelChange)="onQuantityInput(row, $event)" (keydown)="onQuantityKeydown($event)"
                [disabled]="row.available <= 0" [class.cursor-not-allowed]="row.available <= 0"
                class="dg-qty-input w-24 rounded-md border px-2 py-1 text-center dark:bg-transparent">
              }
            </div>
          </td>
        </tr>
        } @empty {
        <tr>
          <td [attr.colspan]="isReadonly ? 2 : 3">
            <div class="text-secondary flex h-32 items-center justify-center text-sm">
              {{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.EMPTY' | t }}
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- footer -->
  <div class="flex flex-wrap items-center justify-end gap-3 border-t px-6"
    [ngClass]="shortScreen ? 'py-2' : 'py-4'">
    @if (isReadonly) {
    <button mat-flat-button color="primary" type="button" (click)="cancel()">{{ 'GENERAL.CLOSE' | t }}</button>
    } @else {
    <button mat-stroked-button type="button" (click)="cancel()">{{ 'GENERAL.CANCEL' | t }}</button>
    <button mat-flat-button color="primary" type="button" [disabled]="!canConfirm" (click)="confirm()"
      [matTooltip]="canConfirm ? '' : ('DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.CONFIRM_DISABLED_TOOLTIP' | t)">
      {{ 'DOCUMENT_GENERATE.WAREHOUSE_DISTRIBUTION_MODAL.CONFIRM' | t }}
    </button>
    }
  </div>
</div>
